module.exports = __webpack_public_path__ + "static/img/logo.1bf3f558.svg";